/* v2: description videos load + play only near the viewport (see main-product.liquid).
   Re-queries on every check instead of observing fixed nodes: the description's own
   scripts re-render parts of it after load, which orphaned observed elements. */
(function () {
  'use strict';
  var ticking = false;
  function check() {
    ticking = false;
    var vh = window.innerHeight || 800;
    var vids = document.querySelectorAll('video[data-vx-lazy]');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i], r = v.getBoundingClientRect();
      var near = r.bottom > -300 && r.top < vh + 300;
      if (near) {
        if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; }
        if (v.paused) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (v.getAttribute('src') && !v.paused) {
        v.pause();
      }
    }
  }
  function schedule() { if (!ticking) { ticking = true; setTimeout(check, 120); } }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule);
  schedule();
})();
